async function request(url: string, opts: RequestInit): Promise<unknown> {
  const res = await fetch(url, opts);

  const json = await res.json();
  if (json.error != null) {
    console.error(json.error);
    throw new Error(json.error.message);
  }

  return json;
}

/** Facebook Graph API client. */
export class FBClient {
  constructor (private readonly accessToken: string) {
  }

  async post (endpoint: string, body: unknown): Promise<unknown> {
    return request(this.createUrl(endpoint), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  }

  async get (endpoint: string): Promise<unknown> {
    return request(this.createUrl(endpoint), {
      method: 'GET',
    });
  }

  private createUrl (endpoint: string): string {
    const url = new URL('https://graph.facebook.com/v16.0/' + endpoint);
    url.searchParams.set('access_token', this.accessToken);
    return url.href;
  }
}
